import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import DashboardPage from "@/pages/DashboardPage";
import AllLeadsPage from "@/pages/AllLeadsPage";
import NewLeadPage from "@/pages/NewLeadPage";
import LeadProfilePage from "@/pages/LeadProfilePage";
import FunnelPage from "@/pages/FunnelPage";
import FollowUpsPage from "@/pages/FollowUpsPage";
import MastersPage from "@/pages/MastersPage";
import PaymentsPage from "@/pages/PaymentsPage";
import ConsultantFormPage from "@/pages/ConsultantFormPage";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/consultant-form/:token" element={<ConsultantFormPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="leads" element={<AllLeadsPage />} />
        <Route path="leads/new" element={<NewLeadPage />} />
        <Route path="leads/:leadId" element={<LeadProfilePage />} />
        <Route path="follow-ups" element={<FollowUpsPage />} />
        <Route path="funnel" element={<FunnelPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="masters" element={<MastersPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
